import { format as dateFormat, parseISO } from 'date-fns';
import { enCA, frCA } from 'date-fns/locale';
import { useTranslation } from 'react-i18next';

type DateTimeProps = {
  value: string;
  format: string;
  showTimeZone?: boolean;
};

export const DateTime = ({
  value,
  format,
  showTimeZone = false,
}: DateTimeProps) => {
  const { i18n } = useTranslation();
  let locale = enCA;
  if (i18n.language === 'fr') {
    locale = frCA;
  }

  const date = parseISO(value);
  const formatted = dateFormat(date, format, { locale });

  if (!showTimeZone) {
    return <>{formatted}</>;
  }

  const timeZoneName = new Intl.DateTimeFormat(locale.code, {
    hour: 'numeric',
    timeZoneName: 'short',
  })
    .formatToParts(date)
    .find((part) => part.type === 'timeZoneName')?.value;

  return <>{timeZoneName ? `${formatted} ${timeZoneName}` : formatted}</>;
};
